import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Vat } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class VatService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getVat(
    id,
    schema = {
      id: null,
      name: null,
    }
  ): Promise<Vat> {
    return new Vat(await this.core.services.vat.getById(id, schema))
  }

  async getVats(
    params: any = {},
    schema: any = { id: null, name: null, percent: null, default: null }
  ): Promise<{
    items: Vat[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.vat.getList(params, schema)
  }

  createVat(vat: Partial<Vat>, schema: any): Promise<Vat> {
    return this.core.services.vat.create(vat, schema)
  }

  updateVat(vat: Partial<Vat>, schema: any): Promise<Vat> {
    return this.core.services.vat.update(vat, schema)
  }

  deleteVat(vat: Partial<Vat>): Promise<Vat> {
    return this.core.services.vat.delete(vat)
  }
}
